module.exports = __webpack_public_path__ + "static/media/phantom-strike.5bcd68cf.png";